exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slide-app-enter{opacity:0}.slide-app-enter-active{animation:slide-app-in ease-out .3s;transition:opacity .3s}.slide-app-leave-active{transition:opacity .2s;opacity:0;position:absolute}@keyframes slide-app-in{0%{transform:translateX(500px)}to{transform:translateX(0)}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4803b63b","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/screens/Application.vue
// module id = 36
// module chunks = 0